function About() {
  return (
    <>
      <h1 className='text-6xl mb-4'>Github Tracker</h1>
      <p className='mb-4 text-2xl font-light'>
      Recruiters can search GitHub profiles and view profile details with the help of our React app
      </p>
    </>
  )
}

export default About
